import layout from '@/layout/index'
import chargingMonitor from '@/module/operatingCenter/page/chargingMonitor'
import siteMonitor from '@/module/operatingCenter/page/siteMonitor'
import deviceControl from '@/module/operatingCenter/page/deviceControl'
import stationRecord from '@/module/operatingCenter/page/station'
import videoMinitor from '@/module/operatingCenter/page/videoMinitor'
import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
    // 默认进入此页面
    path: '/operatingCenter',
    component: layout,
    redirect: 'operatingCenter/chargingMonitor',
    meta: {
        title: i18n.t('deviceControl.OperationsCenter'),
        icon: 'icon-yingxiao1',
        perms: ['bee:operating']
    },
    children: [{
            path: 'chargingMonitor',
            component: chargingMonitor,
            meta: {
                icon: 'icon-yingxiao1',
                title: i18n.t('chargingMonitor.title'),
                perms: ['bee:res:chargingMonitor']
            }
        }, {
            path: 'siteMonitor',
            component: siteMonitor,
            meta: {
                icon: 'icon-yunshuchangzhan',
                title: i18n.t('chang-zhan-jian-kong'),
                perms: ['bee:order:siteMonitor']
            }
        },
        {
            path: 'deviceControl',
            component: deviceControl,
            meta: {
                icon: 'icon-shebei2',
                title: i18n.t('deviceControl.EquipmentControl'),
                perms: ['bee:res:deviceControl']
            }
        },
        // {
        //   path: 'videoMinitor',、
        //   component: videoMinitor,
        //   meta: {icon: 'icon-shipin1', title: '视频监控'}
        // },
        {
            path: 'alaramMonitor',
            component: () =>
                import ("@/module/operatingCenter/page/alarm/alarmManage.vue"),
            meta: {
                icon: 'icon-gaojing1',
                title: i18n.t('alaramMonitor.title'),
                perms: ['bee:ops:alarmRecord']
            }
        },
        {
            path: 'paramMonitor',
            component: () =>
                import ("@/module/operatingCenter/page/param/paramManage.vue"),
            meta: {
                icon: 'icon-caozuo',
                title: i18n.t('paramMonitor.paramSetting'),
                perms: ['bee:ops:paramControl']
            }
        },
        {
            path: 'stationRecord',
            component: stationRecord,
            meta: {
                icon: 'icon-shipin1',
                title: i18n.t('chang-zhan-ji-lu'),
                perms: ['bee:res:stationRecord']
            },
            hidden: true
        }
    ]
}]


// WEBPACK FOOTER //
// ./src/module/operatingCenter/router/index.js